import { useEffect, useRef } from 'react'
import styled from 'styled-components'
import { trackEvent } from '../../../../common/services/intercom'
import { OldButton } from '../../../generic'
import FamilyPortalPaymentOptions from './FamilyPortalPaymentOptions'
import { BodyText, Header } from './FamilyPortalStyles'

interface FamilyPortalPaymentProps {
  fields: any
  data: any
  formId: string
  onComplete: (callback: () => void) => void
  setFormField: (args: { key: string; value: any }) => void
  goToNextStep?: () => void
  mixpanel: any // Define the type for mixpanel
}

export default function FamilyPortalPayment({
  data,
  fields,
  formId,
  goToNextStep,
  mixpanel,
  onComplete,
  setFormField
}: FamilyPortalPaymentProps) {
  const formRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (formRef.current) formRef.current.scrollIntoView()
  }, [])

  const handleSubmit = () => {
    onComplete(goToNextStep!) // pass in goToNextStep as a callback
    trackEvent('CO_family_set_payment')
    mixpanel.track('CO_family_set_payment', {
      familyPaymentType: fields.familyPaymentType
    })
  }

  const { residents, homeName } = data
  const activeResidents = residents.length
  const btnDisabled = !fields.familyPaymentType

  return (
    <Container>
      <div style={{ height: 80 }} ref={formRef} />
      <Header>Family App Setup</Header>
      <BodyText>
        Choose how you would like the billing to be set up for the {homeName}{' '}
        Family App.
      </BodyText>
      <FamilyPortalPaymentOptions
        activeResidents={activeResidents}
        fields={fields}
        formId={formId}
        setFormField={setFormField}
      />
      <ButtonBodyText>
        Note: The monthly bill will increase or decrease depending on the number
        of active profiles.
      </ButtonBodyText>
      <OldButton
        onClick={() => !btnDisabled && handleSubmit()}
        disabled={btnDisabled}
        type="add"
        text="Complete Setup"
        style={{ height: 40, marginTop: 19 }}
      />
    </Container>
  )
}

const ButtonBodyText = styled.div`
  line-height: 22px;
  text-align: center;
`

const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin: auto;
  max-width: 960px;
`
